import React, { Component } from 'react'
import Table from "../../../../components/UI/Table/Table";
import './Table.css';
import { tableColumns } from './constant';

class TableView extends Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidUpdate(prevProps) {

  }

  render() {
    return (
      <Table
        data={[this.props.data]}
        columns={tableColumns}
        showPagination={false}
      />
    )
  }
}

export default TableView
